import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { FormattedMessage, useIntl } from "react-intl";
import { PatientDetailsFormInputs } from "../../../../models/users.interface";
import ConnectForm from "../../../Shared/ConnectForm/ConnectForm";
import EntitySelectFormInput from "../../../Shared/EntitySelectFormInput/EntitySelectFormInput";
import { FormWarning } from "@shltelemedicine/shl-ui-lib";
import PatientsIcon from "../../../Shared/PatientsIcon/PatientsIcon";
import PrescribingPhysicianSelectFormInput from "../PrescribingPhysicianSelectFormInput/PrescribingPhysicianSelectFormInput";

type PatientOrgInfoInputsProps = {
  disabled?: boolean;
  entityReadonly?: boolean;
};
const PatientOrgInfoInputs = ({
  disabled,
  entityReadonly,
}: PatientOrgInfoInputsProps) => {
  const intl = useIntl();
  const entityRequired = intl.messages[
    "MANAGEMENT.ADD_USER.ENTITY_REQUIRED"
  ] as string;
  const physicianRequired = intl.messages[
    "MANAGEMENT.ADD_PATIENT.PHYSICIAN_REQUIRED"
  ] as string;
  return (
    <ConnectForm<PatientDetailsFormInputs>>
      {({ control, formState: { errors: formErrors } }) => {
        return (
          <>
            <Form.Group className="mb-3">
              <Form.Label className="mb-1 font-md d-flex align-items-center">
                <span className="prim-color">*</span>
                <span className="mx-sm">
                  <FormattedMessage
                    id="MANAGEMENT.ENTITY"
                    defaultMessage="Entity"
                  />
                  :
                </span>
                <span className="mx-1"></span>
                {!!formErrors?.entity && (
                  <FormWarning
                    className="font-sm flex-grow-1"
                    message={entityRequired}
                  />
                )}
              </Form.Label>

              <EntitySelectFormInput
                required
                control={control}
                disabled={entityReadonly || disabled}
                isInvalid={!!formErrors?.entity}
                restricted={"non-pro"}
              />
            </Form.Group>

            <Form.Row>
              <Col>
                <Form.Label className="mb-1 font-md d-flex align-items-center">
                  <span className="prim-color">*</span>
                  <span className="mx-sm">
                    <FormattedMessage
                      id="PATIENT.PRESCRIBING_PHYSICIAN"
                      defaultMessage="Physician"
                    />
                    :
                  </span>
                  <span className="mx-1"></span>
                  {!!formErrors?.prescribingPhysician && (
                    <FormWarning
                      className="font-sm flex-grow-1"
                      message={physicianRequired}
                    />
                  )}
                </Form.Label>

                <PrescribingPhysicianSelectFormInput
                  required
                  control={control}
                  disabled={disabled}
                  isInvalid={!!formErrors?.prescribingPhysician}
                />
              </Col>

              <Col lg={12} xl={5} className="mt-2 mt-xl-0">
                <div className="d-flex flex-column align-items-xl-end h-100 justify-content-around">
                  <Form.Label className="mb-1 font-md d-flex align-items-center">
                    <span className="mx-sm">
                      <FormattedMessage
                        id="PATIENT.ACCOUNT_TYPE"
                        defaultMessage="Account Type"
                      />
                    </span>
                  </Form.Label>
                  <div className="d-flex align-items-center">
                    <PatientsIcon />
                    <span className="mx-2">
                      <FormattedMessage
                        id="PATIENT.ECG.PATIENT"
                        defaultMessage="Patient"
                      />
                    </span>
                  </div>
                </div>
              </Col>
            </Form.Row>
          </>
        );
      }}
    </ConnectForm>
  );
};

export default PatientOrgInfoInputs;
